import { AgGridReact } from 'ag-grid-react';
import { useSelector } from "react-redux";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
// import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Row,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";

export const ElectricalSubgroupGrid = ({
  row,
  refetch,
  setRefetch,
  handleNotification,
  setSelectedValue,
  selectedValue
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  console.log(refetch);

  console.log(row);


  const columnDefs = [
    {
      headerName: "Serial No.",
      field: "serialNo",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Group ID",
      field: "groupID",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Sub Group ID",
      field: "subGroupID",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Sub-Group Name",
      field: "subGroupName",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Group Name",
      field: "groupName",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Delete",
      flex:1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              onClick={() => {
                console.log(params.data);
                modalOpen(params.data);
                // params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button> */}

            <Popconfirm
              title="Delete  Sub Group"
              description="Are you sure to delete this Sub Group?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                console.log(params.data);
                deleteConverter(params.data);
                // params.data.actions.confirmDelete(params.data.groupID);
              }}
              trigger="click"
            > 
               <Button className="text-red-500 border-red-500">
                <DeleteOutlined className="text-red-500 "/>
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };
  
  function getGroupID(group) {
    const { subGroupID } = group; 
    return { subGroupID };
  }
  console.log(selectedValue)

  const deleteConverter = (formValues) => {
    console.log(formValues);
    setSelectedValue(formValues.groupID)

    const body = getGroupID(formValues);

    const url = `${APIConstants.ELECTRICAL_SUB_GROUP_DELETE}`;

    console.log(url);
    console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      console.log(res);
      setRefetch(!refetch);
      handleNotification(res.message, "error");
    });
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const rowData = addSerialNumbers(row);
  function addSerialNumbers(objectsArray) {
    return objectsArray.map((obj, index) => ({
        ...obj,
        serialNo: index + 1
    }));
  }
  console.log(rowData); 
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)


  return (
    <div
    // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
    className={`${isdarkMode ? "ag-theme-alpine" : "ag-theme-quartz"}`}
    style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary, 
      '--ag-header-foreground-color': '#fff', 
      height: "80vh", width: "100%", overflowY: "auto" 
    }}
    >
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        pagination={true}
          domLayout="normal"
      />
    </div>
  );
};
